import { Check } from "lucide-react";

export function PrioritySection({ t }) {
    return (
        <section className="section priority-section" id="about" data-testid="reset365-priority-section">
            <div className="page-width">
                <div className="priority-intro reveal">
                    <p className="eyebrow eyebrow--light" data-testid="reset365-priority-eyebrow">{t.eyebrow}</p>
                    <h2 data-testid="reset365-priority-title">{t.title}</h2>
                    <p data-testid="reset365-priority-body">{t.body}</p>
                </div>
                <div className="priority-grid">
                    {t.benefits.map((benefit, index) => (
                        <article className="priority-card reveal" key={benefit.title} data-testid={`reset365-priority-benefit-${index + 1}`}>
                            <span className="priority-card__number">0{index + 1}</span>
                            <Check size={20} strokeWidth={2} aria-hidden="true" />
                            <h3>{benefit.title}</h3>
                            <p>{benefit.text}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
